import React, {Component} from 'react';
import {Button, Card, Col, Form, Input, InputNumber, message, Row, Select} from 'antd';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

import {BackBtn} from '@comm/BackBtn';

import FlowOp from '@comm/workflow/submitOp';

import {queryIncCustomInfo} from '@api/incubator/custom';
import {
  queryCustomAvailable,
  queryCustomDoing,
  queryIncuAvailable,
  queryInvoiceDelete,
  queryInvoiceSave,
} from '@api/incubator/invoice';
import {queryInvoiceContent, queryInvoiceType} from '@api/core/dict';
import util from '@util/index';
import {queryOrgList} from "@api/core/org";
import TableFile from '../comm/TableFile';
import ModalFileList from '../comm/ModalFileList';
import SelectCustom from '../comm/SelectCustom';

const FormItem = Form.Item;
const { Option } = Select;
class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceType: [],
      fileList: props.data ? props.data.files : [],
      submiting: false,
      invoiceContent: [],
      cusAvailable: 0,
      cusDoing: 0,
      customUuid: props.data ? props.data.customUuid : '',
      type: props.data ? props.data.type : '0',
      customInfo: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getOrgList();
    this.getInvoiceType();
    this.getInvoiceContent();
    // this.getIncuAvailable();
    if (this.props.data) {
      this.customUuid = this.props.data.customUuid;
      this.getCustomAvailable();
      this.getCustomDoing();
    }
  }

  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  getOrgList = () => {
    const { data, incuInfo } = this.props;
    queryOrgList({
        type: 1,
        uuid: 'F58BDBC0066B4FB0A8E54BCAF77DA727',
      })
      .then(res => {
        if (data && data.companyUuid) {
          this.initCompany(res.data, data.companyUuid);
        } else if (incuInfo.companyUuid) {
          this.initCompany(res.data, incuInfo.companyUuid);
        }
      });
  };

  // 初始化开票公司名称
  initCompany = (org, key) => {
    const currentCompany = org.find(item => item.uuid === key);
    this.setState({
      company: currentCompany ? currentCompany.name : '',
    });
    this.props.form.setFieldsValue({
      company: currentCompany ? currentCompany.name : '',
    });
  };

  getInvoiceType = () => {
    queryInvoiceType().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          invoiceType: res.data,
        });
      }
    });
  };

  getInvoiceContent = () => {
    queryInvoiceContent().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          invoiceContent: res.data,
        });
      }
    });
  };

  getIncuAvailable = () => {
    queryIncuAvailable({
        incubatorUuid: this.props.params.uuid,
        type: this.type || '',
      })
      .then(res => {});
  };

  getCustomAvailable = () => {
    const { data } = this.props;
    queryCustomAvailable({
        customUuid: this.customUuid,
        incubatorUuid: data ? data.incubatorUuid : this.props.params.uuid,
        type: this.type || '0',
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            cusAvailable: res.data.avaliable,
          });
        }
      });
  };

  getCustomDoing = () => {
    const { data } = this.props;
    queryCustomDoing({
        customUuid: this.customUuid,
        incubatorUuid: data ? data.incubatorUuid : this.props.params.uuid,
        type: this.type || '0',
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            cusDoing: res.data.doing,
          });
        }
      });
  };

  componentWillReceiveProps(nextProps) {}

  invoiceSave = params => {
    this.setState({
      submiting: true,
    });
    queryInvoiceSave(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/invoice_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleDelete = uuid => {
    queryInvoiceDelete({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/invoice_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleChooseFile = params => {
    this.setState({
      fileList: params,
      showFileTips: params.length === 0,
    });
  };

  validateFile = () => {
    const { fileList } = this.state;
    if (!fileList.length) {
      message.warn('没有选择附件！');
      this.setState({
        showFileTips: true,
      });
      return false;
    }
    return true;
  };

  submit = op => e => {
    if (e) {
      e.preventDefault();
    }
    const { data } = this.props;
    const { fileList } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.validateFile()) {
          return;
        }
        if (data && data.uuid) {
          values.uuid = data.uuid;
        }
        const params = {
          ...values,
          files: fileList,
          link: values.links,
        };
        if (op === 'audit') {
          this.invoiceSave(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  handleComChange = (e, option) => {
    this.incubatorUuid = e;
    this.props.form.setFieldsValue({ company: option.props.children });
  };

  handleCustomChange = (e, option) => {
    this.customUuid = e;
    this.setState({
      customUuid: e,
    });
    this.props.form.setFieldsValue({ custom: option.props.children });
    this.getCustomAvailable();
    this.getCustomDoing();
    this.getIncCustomInfo();
  };

  handleTypeChange = (e, option) => {
    this.type = e;
    this.getCustomAvailable();
    this.getCustomDoing();
    this.setState({
      type: e,
    });
  };

  handleConfirmPrice = (rule, value, callback) => {
    const { getFieldValue } = this.props.form;
    const { cusAvailable } = this.state;
    const max = cusAvailable;
    if (max >= 0 && getFieldValue('price') > max) {
      callback('开票金额超出限制！');
    }
    callback();
  };

  getIncCustomInfo = () => {
    queryIncCustomInfo({
        customUuid: this.customUuid,
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            customInfo: res.data,
          });
        }
      });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      invoiceType,
      invoiceContent,
      type,
      cusAvailable,
      cusDoing,
      fileVisible,
      fileList,
      customUuid,
      showFileTips,
      company,
      customInfo,
      submiting,
    } = this.state;
    const { data, incuInfo } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };

    const ItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    getFieldDecorator('company', { initialValue: data ? data.company : '' });
    getFieldDecorator('companyUuid', {
      initialValue: data ? data.companyUuid : incuInfo.companyUuid,
    });
    getFieldDecorator('custom', { initialValue: data ? data.custom : '' });
    return (
      <Form>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <FlowOp handleClick={this.submit} loading={submiting} />
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <Card title="开票申请">
          <Row>
            <Col span={10}>
              <FormItem label="开票公司名称" {...ItemLayout}>
                {company}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="可开票金额" {...ItemLayout}>
                <span>
                  {util.numberFormat(cusAvailable)}元
                  {cusDoing ? `（审核中：${util.numberFormat(cusDoing)}元）` : null}
                </span>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="客户名称" {...ItemLayout}>
                {getFieldDecorator('customUuid', {
                  rules: [{ required: true, message: '请选择客户!' }],
                  initialValue: data ? data.customUuid : '',
                })(
                  <SelectCustom
                    onChange={this.handleCustomChange}
                    incubatorUuid={data ? data.incubatorUuid : this.props.params.uuid}
                    customName={data ? data.custom : ''}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="开票类型" {...ItemLayout}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择开票类型!' }],
                  initialValue: data ? data.type : type,
                })(
                  <Select onChange={this.handleTypeChange}>
                    {invoiceType.map(item => (
                      <Option key={item.value}>{item.key}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="开票内容" {...ItemLayout}>
                {getFieldDecorator('content', {
                  rules: [{ required: true, message: '请输入开票金额!' }],
                  initialValue: data ? data.content : '',
                })(
                  <Select>
                    {invoiceContent.map(item => (
                      <Option key={item.value}>{item.key}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="开票金额" {...ItemLayout}>
                {getFieldDecorator('price', {
                  rules: [
                    {
                      required: true,
                      message: '请输入开票金额!',
                    },
                    {
                      validator: this.handleConfirmPrice,
                    },
                  ],
                  initialValue: data ? data.price : '',
                })(<InputNumber style={{ width: '100%' }} />)}
              </FormItem>
            </Col>
            {type === '0' || type === '1' ? (
              <Col span={10}>
                <FormItem label="纳税人识别号" {...ItemLayout}>
                  {getFieldDecorator('idCode', {
                    rules: [{ required: true, message: '请输入开票金额!' }],
                    initialValue: data
                      ? data.idCode
                      : `${customInfo.taxCode ? customInfo.taxCode : ''}`,
                  })(<Input />)}
                </FormItem>
              </Col>
            ) : null}
            {type === '0' ? (
              <Col span={10}>
                <FormItem label="地址及电话" {...ItemLayout}>
                  {getFieldDecorator('links', {
                    rules: [{ required: true, message: '请输入地址及电话!' }],
                    initialValue: data
                      ? data.link
                      : `${customInfo.contactTel ? customInfo.contactTel : ''}`,
                  })(<Input />)}
                </FormItem>
              </Col>
            ) : null}
            {type === '0' ? (
              <Col span={10}>
                <FormItem label="开户行及帐号" {...ItemLayout}>
                  {getFieldDecorator('bankCode', {
                    rules: [{ required: true, message: '请输入开票金额!' }],
                    initialValue: data
                      ? data.bankCode
                      : `${customInfo.accountBank ? customInfo.accountBank : ''}${
                          customInfo.account ? customInfo.account : ''
                        }`,
                  })(<Input />)}
                </FormItem>
              </Col>
            ) : null}
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="相关附件" {...ItemLayout2}>
                {customUuid ? <a onClick={() => this.handleFileVisible(true)}>选择附件</a> : null}
                {showFileTips ? (
                  <span style={{ color: 'red', paddingLeft: '10px' }}>附件必须上传！</span>
                ) : null}
                {fileList.length > 0 ? (
                  <TableFile dataSource={fileList} handleChooseFile={this.handleChooseFile} />
                ) : null}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="开票说明" {...ItemLayout2}>
                {getFieldDecorator('reason', {
                  rules: [{ required: true, message: '请输入开票说明!' }],
                  initialValue: data ? data.reason : '',
                })(
                  <Input.TextArea
                    placeholder="开票说明"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="开票备注" {...ItemLayout2}>
                {getFieldDecorator('remark', {
                  initialValue: data ? data.remark : '',
                })(
                  <Input.TextArea
                    placeholder="开票备注"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
        {fileVisible ? (
          <ModalFileList
            customUuid={customUuid}
            fileVisible={fileVisible}
            selectedRows={fileList}
            handleCancel={this.handleFileVisible}
            handleChooseFile={this.handleChooseFile}
          />
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  incuInfo: state.incubator_base,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/FormBase.js